<form novalidate #advanceForm="ngForm">
  <div class="setup">
    <div class="section-container">
      <div class="label-data label">
        <div class="label">Web proxy</div>
      </div>
      <div class="proxy-section">
        <div class="proxy-item">
          <div class="proxy-item-wrapper" (click)="selectProxy('Default')">
            <div class="proxy-icon">
              <i *ngIf="webProxyOption !== 'Default'" class="mdi mdi-radiobox-blank"></i>
              <i *ngIf="webProxyOption === 'Default'" class="blue-icon mdi mdi-radiobox-marked"></i>
            </div>
            <div class="proxy-item-content">
              <div class="label column">Default</div>
              <div class="description">Use proxy configured at the originator</div>
            </div>
          </div>
        </div>
        <div class="proxy-item">
          <div class="proxy-item-wrapper" (click)="selectProxy('None')">
            <div class="proxy-icon">
              <i *ngIf="webProxyOption !== 'None'" class="mdi mdi-radiobox-blank"></i>
              <i *ngIf="webProxyOption === 'None'" class="blue-icon mdi mdi-radiobox-marked"></i>
            </div>
            <div class="proxy-item-content">
              <div class="label column">None</div>
              <div class="description">Do not use a proxy</div>
            </div>
          </div>
        </div>
        <div class="proxy-item custom-proxy">
          <div class="proxy-item-wrapper" (click)="selectProxy('Custom')">
            <div class="proxy-icon">
              <i *ngIf="webProxyOption !== 'Custom'" class="mdi mdi-radiobox-blank"></i>
              <i *ngIf="webProxyOption === 'Custom'" class="blue-icon mdi mdi-radiobox-marked"></i>
            </div>
            <div class="proxy-item-content">
              <div class="label column">Custom</div>
              <div class="description">Configure a proxy for this test</div>
            </div>
          </div>
          <form name="proxyform" #proxyForm="ngForm">
            <div class="group proxy-url">
              <p>Custom proxy URL</p>
              <input
                autocomplete="off"
                class="input-data"
                [ngClass]="{ disabled: webProxyOption !== 'Custom' }"
                type="text"
                [(ngModel)]="proxyURL"
                name="proxyURL"
                (ngModelChange)="proxyURLChange()"
                #proxyURLInput="ngModel"
                required
                maxlength="50"
                [disabled]="webProxyOption !== 'Custom'"
              />
              <div
                class="error"
                *ngIf="proxyURLInput.invalid && (proxyURLInput.dirty || proxyURLInput.touched)"
              >
                <mat-error *ngIf="proxyURLInput.errors.maxlength">Proxy URL is too long.</mat-error>
                <mat-error *ngIf="proxyURLInput.errors.required">Proxy URL is required.</mat-error>
                <mat-error *ngIf="proxyURLInput.errors.regex && !proxyURLInput.errors.required">{{
                  proxyURLValidationMsg
                }}</mat-error>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</form>
